/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserCompactDTO } from './user-compact-dto';


export interface ServizioOperatoreAssegnazioneDTO { 
    id?: string;
    version?: number;
    ruolo_servizio?: ServizioOperatoreAssegnazioneDTORuoloServizioEnum;
    user?: UserCompactDTO;
    created_at?: string;
    updated_at?: string;
}
export enum ServizioOperatoreAssegnazioneDTORuoloServizioEnum {
    OP_SCUOLA = 'OP_SCUOLA',
    OP_CENTRO_COTTURA = 'OP_CENTRO_COTTURA'
};



